import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Col, Row } from '_zari/core'

import { EstadosOSE } from 'constants/index'

import { ZrSwal } from 'utils'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

const BotonesEnvioSection = ({ documentos, repetirConsultaDocumentos }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickEnviar = React.useCallback(() => {
    const cantidadDocumentos = documentos.length

    if (cantidadDocumentos === 0) {
      __zariContext.snack('error', 'No hay documentos pendientes de envio.')
      return
    }

    if (documentos.filter(x => x.estadoOSE === EstadosOSE.ENPROCESO || x.estadoOSE === EstadosOSE.PROCESADO).length > 0) {
      __zariContext.snack('error', 'No se puede emitir documentos con estado PENDIENTE o ACEPTADO.')
      return
    }

    ZrSwal.showAlert({
      tipo: 'info',
      mensaje: `Se comunicarán ${cantidadDocumentos} documentos, mediante resumen, a SUNAT. Desea continuar?`,
      onSuccess: () => {
        __zariContext.loader.open(`Enviando resumen de ${cantidadDocumentos} documentos a SUNAT. `)

        FacturacionHistorialService.enviarDocumentosxIdsAsResumen(documentos.map(x => x._id))
          .then(({ data }) => {
            __zariContext.snack(
              'success',
              data ? (
                <>
                  <span>Proceso de envío culminado.</span> <br />
                  <span>{`DOCUMENTO: ${data.fileName}.`}</span> <br />
                  <span>{`TICKET: ${data.ticket}.`}</span>
                </>
              ) : (
                'Proceso de envío culminado.'
              )
            )
          })
          .catch(({ data: { error } }) => {
            __zariContext.snack('error', error)
          })
          .finally(() => {
            __zariContext.loader.close()
            repetirConsultaDocumentos()
          })
      },
      showCerrar: true
    })
  }, [__zariContext, documentos, repetirConsultaDocumentos])

  return (
    <Row>
      <Col md={12} className='px-4'>
        <Button disabled={documentos.length === 0} block onClick={clickEnviar}>
          Enviar OSE
        </Button>
      </Col>
    </Row>
  )
}

export default React.memo(BotonesEnvioSection)
